import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import createRelationTypeService from '../services/createRelationTypeService';
import RelationTypeForm from './RelationTypeForm';
import { mapFormToRelationType } from '../helpers/mapFormToRelationType';

const EMPTY_ORG_ROLE = {};

const NewRelationType = ({ open, dispatchCreateRelationTypePost, createRelationTypeFetch }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body =>
      dispatchCreateRelationTypePost(
        mapFormToRelationType(body),
        () => navigate(`/relation-types`),
        t
      ),
    [dispatchCreateRelationTypePost, navigate, t]
  );

  if (!open) return null;

  return (
    <RelationTypeForm
      header={t('newRelationType')}
      onSubmit={handleSubmit}
      submitProcessing={createRelationTypeFetch.pending}
      returnRoute="/relation-types"
      cancelRoute="/relation-types"
      data={EMPTY_ORG_ROLE}
    />
  );
};

NewRelationType.propTypes = {
  dispatchCreateRelationTypePost: PropTypes.func.isRequired,
  createRelationTypeFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewRelationType.defaultProps = { open: false };

export default createRelationTypeService(NewRelationType);
